<script lang="ts">
  // Move-to sheet (spec §15): every folder except the current one; a tap moves the selection.
  import { t } from '$lib/i18n';
  import { displayName, folderIcon, folderOrder, pathContext } from '$lib/mail/folders';
  import { store } from '$lib/store';
  import Icon from '../ui/Icon.svelte';
  import Sheet from '../ui/Sheet.svelte';

  const ctx = $derived(pathContext(store.folders));
  const folders = $derived(
    store.folders
      .filter((f) => f.path !== store.currentFolder)
      .map((f) => ({ f, order: folderOrder(f, ctx), name: displayName(f, ctx) }))
      .sort((a, b) => a.order - b.order || a.f.path.localeCompare(b.f.path))
  );

  function close() {
    store.moveSheet = false;
  }
</script>

<Sheet label={t('move')} onclose={close}>
  {#each folders as { f, name } (f.path)}
    <button type="button" class="fbtn big" onclick={() => void store.moveTo(f.path)}>
      <span class="fi"><Icon name={folderIcon(f, ctx)} size={20} /></span><span class="fn">{name}</span>
    </button>
  {/each}
</Sheet>

<style>
  /* @css shell/MoveSheet start */
  .fbtn {
    display: flex;
    align-items: center;
    gap: var(--space-3);
    padding-block: var(--space-3);
    padding-inline: var(--space-3);
    min-block-size: var(--control-lg);
    border-radius: var(--radius-control);
    color: var(--text-body);
    width: 100%;
    text-align: start;
    transition: background var(--duration-fast) var(--ease-standard)
  }

  .fbtn:hover {
    background: var(--surface-sunken)
  }

  .fbtn.big {
    padding: var(--space-3) var(--space-4);
    min-block-size: var(--control-lg)
  }

  .fi {
    width: var(--control-xs);
    display: grid;
    place-items: center
  }

  .fn {
    flex: 1;
    min-width: 0;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis
  }

  .fbtn:active {
    background: var(--mail-pressed)
  }
  /* @css shell/MoveSheet end */
</style>
